interface CustomSelectNavProps {
  navOption: Array<any>;
  nav: number;
  wrapperClassName?: string;
}

const CustomSelectNav = ({ navOption, nav, wrapperClassName }: CustomSelectNavProps) => {
  return (
    <ul className={`flex w-full ${wrapperClassName}`}>
      {navOption.map((item) => (
        <li
          key={item.active}
          onClick={item.handleClick}
          className={`border-b w-full text-center p-2 pt-0 transition duration-500 cursor-pointer ${
            nav === item.active
              ? "border-tomato border-b-2 text-tomato font-bold"
              : "text-darkBorder"
          }`}
        >
          {item.title}
        </li>
      ))}
    </ul>
  );
};

export default CustomSelectNav;
